import { styled, Typography } from '@material-ui/core';
import { grey } from '@material-ui/core/colors';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export type HeadCellProps = {
  text: ReactNode;
  sortDir?: false | 'asc' | 'desc';
  onSort?: () => void;
};

const Text = styled(Typography)({
  textAlign: 'left',
  fontWeight: 'bold',
  color: grey[700],
});

export const HeadCell = ({ text, sortDir, onSort }: HeadCellProps) => {
  const { t } = useTranslation();

  const label = (
    <Text variant="body2">
      {/* @ts-expect-error */}
      {t(text)}
    </Text>
  );

  if (!onSort) return label;

  return (
    <button
      type="button"
      onClick={onSort}
      style={{
        cursor: 'pointer',
        userSelect: 'none',
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        background: 'none',
        border: 'none',
        padding: 0,
      }}
    >
      {label}
      <span style={{ color: grey[500], fontSize: 10, lineHeight: 1 }}>
        {/* eslint-disable-next-line no-nested-ternary */}
        {sortDir === 'asc' ? '▲' : sortDir === 'desc' ? '▼' : '⇅'}
      </span>
    </button>
  );
};
